/**
 * COMMERCE-FISCAL-161A-R1 — Engagement Hub placeholder surface (staging preview only).
 * No games, rewards, economy, or retention events.
 */
import type { StoreV2Lang } from "./store-v2-locale.js";
import { resolveEngagementHubContract } from "./engagement-hub-v2.js";

export function EngagementHubPlaceholderV2(props: {
  lang: StoreV2Lang;
  onBack: () => void;
}) {
  const { lang, onBack } = props;
  const en = lang === "en";
  const hub = resolveEngagementHubContract();

  return (
    <div className="sv2-body" data-testid="sv2-engagement-hub">
      <div className="sv2-section-title">
        🧭 {en ? hub.title_en : hub.title_uk}
      </div>
      <p className="sv2-muted" style={{ marginBottom: 12 }}>
        {en
          ? "Infrastructure preview — adventures arrive later."
          : "Попередній перегляд інфраструктури — пригоди з’являться пізніше."}
      </p>
      <div className="sv2-cabinet-grid" data-testid="sv2-engagement-hub-entries">
        {hub.entries.map((e) => (
          <div
            key={e.id}
            className="sv2-cabinet-tile"
            data-testid={`sv2-engagement-entry-${e.id}`}
            aria-disabled="true"
            style={{ opacity: 0.85, cursor: "default" }}
          >
            <span className="sv2-cabinet-tile-emoji" aria-hidden="true">
              {e.icon}
            </span>
            <span className="sv2-cabinet-tile-label">
              {en ? e.label_en : e.label_uk} — {en ? "soon" : "скоро"}
            </span>
          </div>
        ))}
      </div>
      <button type="button" className="sv2-cta" style={{ marginTop: 16 }} onClick={onBack} data-testid="sv2-engagement-hub-back">
        {en ? "Back" : "Назад"}
      </button>
    </div>
  );
}
